import React from "react";
import { createRoot } from "react-dom/client";
import { MainComponent } from "./MainComponent";
import "./_public/main.css";
document.body.innerHTML = '<div id="app"></div>';
const root = createRoot(document.getElementById("app"));
root.render(React.createElement(MainComponent, null));
